import React, { useMemo } from 'react'
import {
  AdvancedMarker,
  AdvancedMarkerAnchorPoint,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps'
import { Marker } from '@/modules/accredited-establishments/components/Maps'
import { getMarkerProperties } from './FeatureMarker.helpers'
import { EstablishmentGeoJsonFeatureProperties } from '../types'

type TreeMarkerProps = {
  position: google.maps.LatLngLiteral
  properties: EstablishmentGeoJsonFeatureProperties
  onMarkerClick: (marker: google.maps.marker.AdvancedMarkerElement) => void
}

const FeatureMarker = ({
  position,
  properties,
  onMarkerClick
}: TreeMarkerProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef()

  const { category, icon } = properties

  const markerProperties = useMemo(() => {
    if (category !== 'SPECIALIST' && icon) {
      return { image: icon }
    }

    return getMarkerProperties(category)
  }, [category, icon])

  return (
    <AdvancedMarker
      ref={markerRef}
      position={position}
      anchorPoint={AdvancedMarkerAnchorPoint.CENTER}
      onClick={() => onMarkerClick(marker!)}
    >
      <Marker {...markerProperties} />
    </AdvancedMarker>
  )
}

export type { TreeMarkerProps }

export { FeatureMarker }
